import {
  Draggable,
  type DraggableProvided,
  type DraggableStateSnapshot,
} from "@hello-pangea/dnd";
import { type ReactElement } from "react";

import { type User as UserType } from "../CrewTransfer.model";
import {
  StyledSelectionCount,
  StyledUser,
  StyledUsername,
  StyledUsersRole,
} from "../styled/user.styled";
const primaryButton = 0;

interface Props {
  user: UserType;
  index: number;
  isSelected: boolean;
  isGhosting: boolean;
  selectionCount: number;
  toggleSelection: (taskId: string) => void;
  toggleSelectionInGroup: (taskId: string) => void;
  multiSelectTo: (taskId: string) => void;
}

const User = ({
  user,
  index,
  selectionCount,
  toggleSelectionInGroup,
  toggleSelection,
  multiSelectTo,
  isGhosting,
  isSelected,
}: Props) => {
  const onClick = (event: any): void => {
    if (event.defaultPrevented || event.button !== primaryButton) return;
    event.preventDefault();
    performAction(event);
  };

  const onTouchEnd = (event: any): void => {
    if (event.defaultPrevented) return;
    event.preventDefault();
    toggleSelectionInGroup(user.id);
  };

  const wasToggleInSelectionGroupKeyUsed = (
    event: MouseEvent | KeyboardEvent,
  ): boolean => {
    const isUsingWindows = navigator.platform.includes("Win");
    return isUsingWindows ? event.ctrlKey : event.metaKey;
  };

  const wasMultiSelectKeyUsed = (event: MouseEvent | KeyboardEvent): boolean =>
    event.shiftKey;

  const performAction = (event: MouseEvent | KeyboardEvent): void => {
    const { id } = user;
    if (wasToggleInSelectionGroupKeyUsed(event)) {
      toggleSelectionInGroup(id);
      return;
    }

    if (wasMultiSelectKeyUsed(event)) {
      multiSelectTo(id);
      return;
    }

    toggleSelection(id);
  };

  return (
    <Draggable draggableId={user.id} index={index}>
      {(
        provided: DraggableProvided,
        snapshot: DraggableStateSnapshot,
      ): ReactElement => (
        <StyledUser
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          onClick={onClick}
          onTouchEnd={onTouchEnd}
          isDragging={snapshot.isDragging}
          isSelected={isSelected}
          isGhosting={isGhosting}
          style={{ ...provided.draggableProps.style }}>
          <StyledUsername>{user.username}</StyledUsername>
          <StyledUsersRole>{user.role}</StyledUsersRole>
          {snapshot.isDragging && selectionCount > 1 && (
            <StyledSelectionCount>{selectionCount}</StyledSelectionCount>
          )}
        </StyledUser>
      )}
    </Draggable>
  );
};
export default User;
